// extracted by mini-css-extract-plugin
module.exports = {"shipping":"ShippingInfo_shipping__gzBRv","item":"ShippingInfo_item__1P5-I","p":"ShippingInfo_p__2iNF_","h3":"ShippingInfo_h3__18EeE"};